import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {withRouter} from 'react-router-dom'
import PageHeader from '../PageHeader'
import RXRButton from '../RXRButton'
import AmenityManagerTable from './AmenityManagerTable'
import Constant from './AmenitiesConstants'
import {AMENITY_TYPE_OPERATIONAL, AMENITY_TYPE_RECREATIONAL} from '../../constants/ModelConstants'
import EmptyStateIconAndMessage from '../EmptyStateIconAndMessage'
import {loadAmenitiesForBuilding} from '../../actions/amenitiesActions'

import Routes from '../../constants/RouteConstants'
import Loader from '../Loader'
import {PageContainer} from '../../assets/styles/layout'
import useBuildingDataRefresh from '../hooks/useBuildingDataRefresh'
import RXRIcon from '../RXRIcon'
import {selectActiveBuildingAndSisterBuildingIds} from '../../reducers/selectors'

function AmenityManagerPage(props) {
  const isMobile = useSelector(state => state.App.isMobile)
  const amenitiesLookup = useSelector(state => state.Amenities.amenitiesLookup)
  const buildingIds = useSelector(selectActiveBuildingAndSisterBuildingIds)
  const dispatch = useDispatch()
  const [isLoadAmenities, setIsLoadAmenities] = useState(true)
  const {activeBuildingId} = useBuildingDataRefresh(async () => {
    await loadAmenitiesForBuilding(dispatch, buildingIds)
    setIsLoadAmenities(false)
  })

  let visibleTableComponent

  if (Object.keys(amenitiesLookup).length === 0) {
    visibleTableComponent = <EmptyStateIconAndMessage message={Constant.NO_AMENITY_MESSAGE} icon={RXRIcon.AMENITIES} />
  } else {
    visibleTableComponent = <AmenityManagerTable amenityType={props.amenityType} />
  }

  if (isLoadAmenities) {
    return <Loader />
  }

  let pageTitle = ''
  if (props.amenityType === AMENITY_TYPE_RECREATIONAL) {
    pageTitle = Constant.RECREATIONAL_RESERVATIONS_PAGE_TITLE
  } else if (props.amenityType === AMENITY_TYPE_OPERATIONAL) {
    pageTitle = Constant.OPERATIONAL_RESERVATIONS_PAGE_TITLE
  }

  return (
    <div style={PageContainer}>
      <PageHeader
        title={pageTitle}
        rightControlComponent={
          <RXRButton
            type={isMobile ? RXRButton.TYPE_DEFAULT : RXRButton.TYPE_LARGE}
            onClick={() => {
            if (props.amenityType === AMENITY_TYPE_RECREATIONAL) {
              props.history.push(Routes.AMENITIES_CREATE_RECREATIONAL)
            } else if (props.amenityType === AMENITY_TYPE_OPERATIONAL) {
                props.history.push(Routes.AMENITIES_CREATE_OPERATIONAL)
              }
            }}
          >
            {Constant.BTN_ADD_AMENITY_MANAGER}
          </RXRButton>
        }
      />

      <div style={{height: '100%'}}>{visibleTableComponent}</div>
    </div>
  )
}

export default withRouter(AmenityManagerPage)
